import { FC, useContext, useRef } from 'react'
import { ToolsContainer, ToolsWrapper } from './Tools.styles'
import { LeftSidebar } from './LeftSidebar/LeftSidebar'
import { StoreContext } from '@components/App'
import { observer } from 'mobx-react'
import { Links } from './Components/Links/Links'
import { CreateIncident } from './Components/CreateIncident/CreateIncident'

export const Tools: FC = observer(() => {
  const store = useContext(StoreContext)
  const { menuWidth, headerHeight } = store.UserInterfaceState.gridDimensions
  const { leftSidebar } = store.UserInterfaceState

  const containerRef = useRef<HTMLDivElement>(null)

  const renderTool = () => {
    switch (leftSidebar?.selectedToolsTab) {
      case 'links':
        return <Links />
      case 'create-incident':
        return <CreateIncident />
      default:
        return <></>
    }
  }

  return (
    <ToolsWrapper $headerHeight={`${headerHeight}px`} $menuWidth={`${menuWidth}px`} ref={containerRef}>
      <LeftSidebar />

      <ToolsContainer>{renderTool()}</ToolsContainer>
    </ToolsWrapper>
  )
})
